// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__38YGx","button":"Pagination_button__2aXR-","progressFraction":"Pagination_progressFraction__3xq8V"};